import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const CasoArchivadoDetalle = React.lazy(
  () => import("../screean/case/caso-archivado-detalle")
);
export function casoArchivadoDetalle() {
  return (
    <Route
      path="/caso-archivado-detalle"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <LazySuspense>
              <CasoArchivadoDetalle />
            </LazySuspense>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
